const checkVariants = () => {
  const variantsWrapper = Array.from(document.querySelectorAll(".qb-product-variants"));
  let variantMissing = false;
  const buyButton = document.getElementById("qb-atc-button");
  variantsWrapper.forEach((wrapper) => {
    if(!variantMissing){
      
      const wrapperSelected = wrapper.querySelector("input:checked");
      if(!wrapperSelected){
         const wrapperName = wrapper.dataset.optionname;
          buyButton.innerHTML = "Please Select " + wrapperName;
        buyButton.style.pointerEvents = "none";
        variantMissing = true
      }
    }
  })
  if(!variantMissing){
    buyButton.innerHTML = "Add To Basket";
        buyButton.style.pointerEvents = "all"
  }
  
}

const addQbPrintSelectors = async (prod) =>{ 
    const printSelectorDiv = document.getElementById("qb-pattern-selector");
    printSelectorDiv.classList.remove("hidden");
printSelectorDiv.innerHTML = "";
  for(let i = 0; i<10; i++){
    printSelectorDiv.innerHTML += `<div class="h-12 w-12 rounded-full animate-mt"></div>`
  }
  const tags = prod.tags1? prod.tags1 : prod.tags;
  const title = prod.title? prod.title : prod.name;
  const imageUrl = prod.featured_image ? prod.featured_image : prod.imageUrl;
  const prodPrice = prod.featured_image? prod.price/100 : prod.price; //check to see iuf nosto or shoipfy product
  const compPrice= prod.listPrice? prod.listPrice : prod.compare_at_price/100;
  const prodVariants = prod.skus? prod.skus : prod.variants
  const prodHandle = prod.handle? prod.handle : prod.url.replace("https://www.myoddballs.com/products/","")
  const prodStyle = tags.find((tag) =>{
      return tag.includes("style-") && !tag.includes("feature-")
    }).replace("style-","")
    const printsUrl = `/search/?view=qb_design_list_by_style&q=${prodHandle}|${prodStyle}`
    const response = await fetch(printsUrl);
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const html = await response.text();
  printSelectorDiv.innerHTML = "";
    printSelectorDiv.innerHTML = html
} 



const initialiseQbSlider = () =>{
    const container = document.getElementById('default-quick-buy-image');
  const outerWrapper = document.getElementById("qb-image-outer-wrapper");
  let thumbnails = Array.from(outerWrapper.querySelectorAll(".product-thumbnail"));
  let totalSlides = thumbnails.length;
  if(totalSlides > 7){
    document.querySelector("#qb-image-outer-wrapper .product-thumbnails").style.justifyContent = "start";
  }else{
    
    document.querySelector("#qb-image-outer-wrapper .product-thumbnails").style.justifyContent = "center";
  }
  let screenWidth = 178;
  const SWIPE_THRESHOLD = 50;

  if (!container) return;

  if(!thumbnails) return

  thumbnails.forEach((thumbnail) =>{
    thumbnail.addEventListener("click", ()=>{
      const newIndex = Number(thumbnail.dataset.slideindex);
       if(currentIndex < totalSlides){
         currentIndex = currentIndex + totalSlides
         goToSlide(currentIndex, false, true)
       }
       if(currentIndex >= totalSlides*2){
         currentIndex = currentIndex - totalSlides
         goToSlide(currentIndex, false,true)
       }
         currentIndex = newIndex - 1 + totalSlides
         goToSlide(currentIndex)
    })
  })
  let currentIndex = totalSlides;
  
  let touchStartX = 0;
  let touchEndX = 0;
  container.style.overflowX = 'hidden';
  container.style.touchAction = 'pan-y'; 

  const goToSlide = (index, isSmooth = true, repo=false) => {
    console.log("going to new slide ")
    console.log(index)
    currentIndex = index;
   if(index < totalSlides && !repo){
     currentIndex = ((totalSlides * 2))
     goToSlide(currentIndex, false, true)
     currentIndex = (totalSlides * 2) -1
   }
   if(index >= totalSlides*2&& !repo){
     currentIndex = ((totalSlides -1))
     goToSlide(currentIndex, false,true)
     currentIndex = (totalSlides) 
   }
    container.scrollTo({
      left: currentIndex * screenWidth,
      behavior: isSmooth? 'smooth' : 'instant'
    });
    const prevThumb = thumbnails.find((thumb) =>
      thumb.classList.contains("active-thumb")
    );
    if (prevThumb) {
      prevThumb.classList.remove("active-thumb");
    }
    const toHighlight = currentIndex + 1 - totalSlides 

    const currentThumb = thumbnails.find(
      (thumb) => thumb.dataset.slideindex == toHighlight
    );
    if (currentThumb) {
      currentThumb.classList.add("active-thumb");
    }
  };

  container.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
  });

  container.addEventListener('touchmove', (e) => {
    touchEndX = e.touches[0].clientX;
  });

  container.addEventListener('touchend', () => {
    const deltaX = touchEndX - touchStartX;
    if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
      if (deltaX < 0 ) {
        goToSlide(currentIndex + 1);
      } else if (deltaX > 0) {
        goToSlide(currentIndex - 1);
      }
    } else {
      goToSlide(currentIndex);
    }
    touchStartX = 0;
    touchEndX = 0;
  });

  window.addEventListener('resize', () => {
    screenWidth = window.innerWidth;
    goToSlide(currentIndex);
  }); 

  setTimeout(()=>{
  goToSlide(currentIndex, false, true);
    
  },500)
  // goToSlide(currentIndex, false);
  // goToSlide(currentIndex, false);
  // goToSlide(currentIndex, false);
  // goToSlide(currentIndex, false);
  // goToSlide(currentIndex, false);
  // goToSlide(currentIndex, false);

    const observer = new MutationObserver(() => {
    resetSlider();
  });

  observer.observe(container, { childList: true, subtree: true });

  function resetSlider() {

    totalSlides = outerWrapper.querySelectorAll(".product-thumbnail").length;
    thumbnails = Array.from(outerWrapper.querySelectorAll(".product-thumbnail"));
      thumbnails.forEach((thumbnail) =>{
        thumbnail.addEventListener("click", ()=>{
          const newIndex = Number(thumbnail.dataset.slideindex) - 1;
          console.log(newIndex)
             currentIndex = newIndex  + totalSlides
             goToSlide(currentIndex)
        })
      })

    if (currentIndex >= totalSlides) {
      currentIndex = totalSlides - 1; 
    }

    goToSlide(totalSlides , false, true);
  }
}

window.buildQb = async (prod, isPrintSwap=false) =>{
  console.log("prod")
  console.log(prod)
  const tags = prod.tags1? prod.tags1 : prod.tags;
  const title = prod.title? prod.title : prod.name;
  const imageUrl = prod.featured_image ? prod.featured_image : prod.imageUrl;
  const images = prod.images? prod.images : prod.alternateImageUrls
  const prodPrice = prod.featured_image? prod.price/100 : prod.price; //check to see iuf nosto or shoipfy product
  const compPrice= prod.listPrice? prod.listPrice : prod.compare_at_price/100;
  const prodVariants = prod.skus? prod.skus : prod.variants
  
  resetQb();
  if(!isPrintSwap){
    const printSelectorDiv = document.getElementById("qb-pattern-selector");
    if(tags.some((item)=>{
      return item == "feature-design-selector"
    })){
      printSelectorDiv.classList.remove("hidden")
      addQbPrintSelectors(prod)
  
    }else{
      printSelectorDiv.classList.add("hidden")
    }
  }
  const qbProdInfo = document.getElementById("qb-prod-info");
  qbProdInfo.value = JSON.stringify(prod);
   
  const qbImageWrapper = document.getElementById("default-quick-buy-image");
  qbImageWrapper.classList.remove("load-animate");
  qbImageWrapper.innerHTML = "";
  const thumbnailWrapper = document.querySelector("#qb-image-outer-wrapper .product-thumbnails");
  thumbnailWrapper.innerHTML = "";
  images.forEach((image, index) =>{
    const ele = document.createElement("img");
    ele.className = "transition duration-100 ease-in-out opacity-100 rounded-sm aspect-square object-cover rounded-lg"
    ele.style.background = "#f3f4f6;"
    ele.src = image;
    ele.width = "168"
    ele.height = "168"
    qbImageWrapper.appendChild(ele);
    const thumbnail = document.createElement("img");
    thumbnail.className = "product-thumbnail transition duration-100 ease-in-out opacity-100 rounded-sm aspect-square object-cover rounded-lg"
    thumbnail.setAttribute("data-slideindex", index + 1)
    thumbnail.src = image;
    thumbnail.width = "40"
    thumbnail.height = "40"
    thumbnailWrapper.appendChild(thumbnail);
  })
  for(let i =0; i <2; i++){
    images.forEach((image, index) =>{
      const ele = document.createElement("img");
      ele.className = "transition duration-100 ease-in-out opacity-100 rounded-sm aspect-square object-cover rounded-lg bg-gray-100"
      ele.src = image;
      ele.style.background = "#f3f4f6;"
      ele.width = "168"
      ele.height = "168"
      qbImageWrapper.appendChild(ele);
    })
  }
  initialiseQbSlider();
  const qbHeader = document.getElementById("default-quick-buy-header-title");
  qbHeader.innerHTML = title.split("-")[0];
  qbHeader.classList.remove("load-animate")
  const qbSubHeader = document.getElementById("default-quick-buy-header-sub-title");
  qbSubHeader.innerHTML = title.split("-")[0];
  qbSubHeader.classList.remove("load-animate")
  const currencySymbol = document.body.getAttribute("currency-symbol")
  const qbPriceDiv = document.getElementById("default-quick-buy-prod-price");
  qbPriceDiv.innerHTML = currencySymbol + prodPrice
  const qbCompDiv = document.getElementById("default-quick-buy-comp-price");
  if(compPrice == prodPrice){
    qbCompDiv.style.display = "none";
  }else{
    qbCompDiv.style.display = "block";
  }
  qbCompDiv.innerHTML = currencySymbol + compPrice

  const variants = prodVariants;
  const options = variants[0].customFields?.filter((item)=>{
    return item.key != "skucode" && item.key != "gtin";  
  }).map((item)=>{
    return item.key
  }) || prod.options;
  const prodOptions = []
  options.forEach((option, index) => {
    const optionName = `option${index + 1}`
    const optionSet = new Set();
    variants.forEach((variant) =>{
      const matchingOption = variant.customFields?.find((item)=>{
        return item.key == option 
      }).value || variant[optionName]
      optionSet.add(matchingOption)
    })
    prodOptions.push({
      "title": option,
      "values" : optionSet
    })
  })
  const variantsDiv  = document.getElementById("qb-product-variants");
  prodOptions.forEach((option) => {
    const titleDiv = document.createElement("div");
    titleDiv.className = "flex justify-between items-center w-full";
    const textDiv = document.createElement("div");
    textDiv.className = "typography typography--body-md uppercase mb-2 font-semibold size-name"
    textDiv.innerHTML = option.title;
    titleDiv.appendChild(textDiv);
    variantsDiv.appendChild(titleDiv)
    const variantsWrapper = document.createElement("div");
    variantsWrapper.setAttribute("data-optionname", option.title)
      variantsWrapper.className="qb-product-variants grid grid-cols-4 gap-3";
    option.values.forEach((value) => {
      const varDiv = createVariantElement(value, option.title, prod)
      variantsWrapper.appendChild(varDiv);
    })
    variantsDiv.appendChild(variantsWrapper)
  })
  checkVariants();
  const qbPopup = document.getElementById("default-quick-buy-popup-content");
  openPopup(qbPopup); 
  
}

const createVariantElement = (sizeName, option, prod) => {
  let optionAvailable = true;

    if (prod.skus?.length > 0) {
      optionAvailable = prod.skus.every((sku) => {
        return !sku.name.includes(sizeName) || sku.availability === "InStock";
      });
    }
    
    if (optionAvailable && prod.variants?.length > 0) {
      optionAvailable = prod.variants.every((variant) => {
        return !variant.title.includes(sizeName) || variant.available;
      });
    }
  const wrapper = document.createElement("div");
  wrapper.className = "product-variant text-xs relative";
  if(!optionAvailable){
    wrapper.classList.add("variant-unavailable")
  }
  wrapper.setAttribute("data-option-value", sizeName);

  const outOfStockMarker = document.createElement("div");
  outOfStockMarker.className = "out-of-stock-marker absolute z-10";
  outOfStockMarker.style.right = "5%";
  outOfStockMarker.style.bottom = "10%";
  outOfStockMarker.innerHTML = `
    <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" width="15" height="15" viewBox="0 0 24 24" stroke="#f00f83" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
    </svg>
  `;

  const label = document.createElement("label");
  label.className = "ooption-value qb-variant-option group relative flex items-center justify-center rounded-md border py-2 px-4 text-xs font-medium font-semibold uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 cursor-pointer bg-white text-gray-900 shadow-sm text-nowrap";
  label.setAttribute("data-active", "ring-2 ring-magenta");

  const input = document.createElement("input");
  input.type = "radio";
  input.name = option;
  input.value = sizeName;
  input.className = "peer sr-only";
  input.setAttribute("data-option-index", "0");
  input.setAttribute("data-option-value", sizeName);

  const styleSpan = document.createElement("span");
  styleSpan.className = "peer-checked:border-transparent items-center flex justify-center peer-checked:bg-magenta-500 peer-checked:text-white peer-checked:hover:bg-pink-700 peer-checked:ring-2 peer-checked:ring-magenta-500 peer-checked:ring-offset-2 border-transparent pointer-events-none absolute -inset-px rounded-md";
  styleSpan.setAttribute("aria-hidden", "true");

  const valueSpan = document.createElement("span");
  valueSpan.className = "option-value relative peer-checked:text-white";

  const del = document.createElement("del");
  del.className = "out-of-stock-marker";
  del.textContent = sizeName;

  const inStock = document.createElement("div");
  inStock.className = "in-stock-marker";
  inStock.textContent = sizeName;

  valueSpan.appendChild(del);
  valueSpan.appendChild(inStock);

  label.appendChild(input);
  label.appendChild(styleSpan);
  label.appendChild(valueSpan);

  wrapper.appendChild(outOfStockMarker);
  wrapper.appendChild(label);

  return wrapper;
}
const resetQb = () => {
  const variantsDiv  = document.getElementById("qb-product-variants");
  variantsDiv.innerHTML  = "";
}


document.addEventListener("click", (e)=>{
  if(event.target.closest("#default-quick-buy-content .add-to-cart-button")){
    const formWrapper = e.target.closest("#default-quick-buy-content");
    const prodForm = formWrapper.querySelector("form");
    const nameInput = prodForm.querySelector('input[name="id"]')
    const qbProdInfo = document.getElementById("qb-prod-info");
    const currentProdInfo = JSON.parse(qbProdInfo.value);
    const checkedInputs = Array.from(formWrapper.querySelectorAll('input:checked')).filter((item)=>{
      return !item.closest(".js-qb-print-swap")
    })
    const checkedValues = (checkedInputs).map((input) =>{
      return input.value
    })
    const chosenVariant = currentProdInfo.skus?.find((variant) =>{
      let toReturn = true;
      checkedValues.forEach((value)=>{
        if(!variant.name.toLowerCase().includes(value.toLowerCase())){
          toReturn = false;
        }
      })
      return toReturn;
    }) ||  currentProdInfo.variants.find((variant) => {
  let allMatch = true;
  checkedValues.forEach((value, index) => {
    const optionName = `option${index + 1}`;
    if (variant[optionName] !== value) {
      allMatch = false;
    }
  });
  return allMatch;
});
    nameInput.value = chosenVariant.id;
    addQbToCart(prodForm, chosenVariant.id, currentProdInfo);
    e.preventDefault();
  }

  

  if(e.target.closest(".qb-variant-option")){
    setTimeout(()=>{
      checkVariants();
    }, 1)
  }
  
  if(e.target.closest(".js-qb-print-swap")){
    const printWrapper = e.target.closest(".js-qb-print-swap");
    const newProd = JSON.parse(printWrapper.querySelector(".js-prod-json").innerHTML);
    buildQb(newProd, true)
    
  }

  
})

const addQbToCart = (form, currentVariant, productData, sellingPlan=false) => {
    return new Promise((resolve, reject) => {

        const formData = new FormData(form);
      if(sellingPlan){
        formData.set('selling_plan', sellingPlan);
      }
        const dataString = new URLSearchParams(formData).toString();
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
            },
            body: dataString,
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return response.json().then((json) => {
                    throw new Error(json.description || 'Failed to add to cart');
                });
            }
        })
        .then(cartItem => {
            const event = new CustomEvent('itemAddedToCart', {
                detail: {
                    variant: currentVariant,
                    product: productData,
                    formData: formData,
                },
            });
            document.dispatchEvent(event);
            const quantityDiv = document.getElementById("cart-items-number");
            const resetRevent = new CustomEvent('revertToCart');
            document.dispatchEvent(resetRevent);

            const cartevent = new CustomEvent('updateCart');
            document.dispatchEvent(cartevent);

            resolve(cartItem); // Resolve the promise when item is successfully added
        })
        .catch(error => {
            console.error('ATC: Error adding to cart:', error);
            reject(error); // Reject the promise if there's an error
        });
    });
}